import { post } from '@/utils/request'

/**
 * 小程序列表 
 * 
 * @param {Number} [page=1] 页码
 * @param {Number} [pagesize=10] 页面大小
 */
export function admin_plugin_wxapp_list(data) {
  return post('admin_plugin_wxapp_list', data)
}

/**
 * 小程序审核列表
 * @param String wxapp_id 小程序id
 */
export function admin_plugin_wxapp_check_list(data) {
  return post('admin_plugin_wxapp_check_list', data)
}

/**
 * 小程序版本列表
 */
export function admin_plugin_wxapp_version_list(data) {
  return post('admin_plugin_wxapp_version_list', data)
}

/**
 * 微信第三方平台转发接口
 * @param id 小程序id
 * @param url url微信第三方平台请求地址
 * @param data 请求参数
 */
export function admin_plugin_wxapp_api(data) {
  return post('admin_plugin_wxapp_api', data)
}
/**
 * 微信隐私协议添加
 * @param id 小程序id
 */
export function admin_plugin_privacysetting(data) {
  return post('admin_plugin_privacysetting', data)
}

/**
 * 微信小程序当前上传代码
 * @param wxapp_id 小程序id
 */
export function admin_plugin_wxapp_code(data) {
  return post('admin_plugin_wxapp_code', data)
}

/**
 * 小程序自动开发开关
 * @param value 是否开启
 */
export function admin_plugin_wxapp_dev_auto(data) {
  return post('admin_plugin_wxapp_dev_auto', data)
}

/**
 * 小程序自动开发模版设置
 * @param value 模板id
 */
export function admin_plugin_wxapp_dev_template_id(data) {
  return post('admin_plugin_wxapp_dev_template_id', data)
}

/**
 * 删除微信小程序
 * @param id 
 */
export function admin_plugin_wxapp_delete(data) {
  return post('admin_plugin_wxapp_delete', data)
}

/**
 * 刷新小程序列表数据 
 */
export function admin_plugin_wxapp_refresh_authorizer_info(data) {
  return post('admin_plugin_wxapp_refresh_authorizer_info', data)
}
